var $ = jQuery;

$(document).on('ready', function(){
    $(document).on('click', '.filter-icon', function() {
        if($(this).hasClass('selected')) {
            $(this).removeClass('selected');

        } else {
            $(this).addClass('selected');
        }
    })
})